// extracted by mini-css-extract-plugin
export default {"__mainView":"home___mainView__anpNJ","__mainViewComplete":"home___mainViewComplete__f7U57","__animationMain":"home___animationMain__1+fn+"};